import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import 'index.scss';
import Pickup from 'components/Pickup';
import * as serviceWorker from './serviceWorker';

import { BrowserRouter as Router } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import handleAnalyticCall from './analytics';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#BB5811"
        },
        secondary: {
            main: "#677406"
        },
        error: {
            main: "#B80818"
        }
    },
    overrides: {
        MuiButton: {
            root: {
                fontSize: 16,
                borderRadius: 0,
                fontWeight: "bold",
                lineHeight: "16px",
                letterSpacing: 1.5
            },
            contained: {
                boxShadow: "none"
            },
            label: {
                fontSize: 16
            }
        },
        MuiLink: {
            root: {
                color: "black"
            }
        },
        MuiDialog: {
            root: {
                fontFamily: [
                    '"Roboto"',
                    '"Archivo"',
                    'sans-serif',
                ].join(',')
            }
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 0
            }
        }
    }
});

ReactDOM.render(
    <StrictMode>
        <Router>
            <MuiThemeProvider theme={theme}>
                <Pickup/>
            </MuiThemeProvider>
        </Router>
    </StrictMode>,
    document.getElementById('root'),
    handleAnalyticCall()
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
